import { render, staticRenderFns } from "./AddEditInfo.vue?vue&type=template&id=fab16f70&scoped=true&"
import script from "./AddEditInfo.vue?vue&type=script&lang=js&"
export * from "./AddEditInfo.vue?vue&type=script&lang=js&"
import style0 from "./AddEditInfo.vue?vue&type=style&index=0&id=fab16f70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab16f70",
  null
  
)

export default component.exports